import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function isJwt(value) {
    return typeof value === 'string' && value.split('.').length === 3;
}

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [token, setToken] = useState(localStorage.getItem('token'));

    useEffect(() => {
        if (isJwt(token)) {
            axios.defaults.headers.common.Authorization = `Bearer ${token}`;
        } else {
            delete axios.defaults.headers.common.Authorization;
        }
    }, [token]);

    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            try {
                const response = await axios.get(`${API}/auth/me`);
                if (!cancelled) {
                    setUser(response.data);
                    if (!isJwt(token)) setToken('session');
                }
            } catch (error) {
                if (!cancelled) {
                    localStorage.removeItem('token');
                    setToken(null);
                    setUser(null);
                }
            } finally {
                if (!cancelled) setLoading(false);
            }
        };
        load();
        return () => { cancelled = true; };
    }, []);

    const login = () => {
        window.location.href = `${API}/auth/discord`;
    };

    const handleCallback = (newToken) => {
        if (isJwt(newToken)) {
            localStorage.setItem('token', newToken);
            setToken(newToken);
        } else {
            localStorage.removeItem('token');
            setToken('session');
        }
    };

    const logout = () => {
        axios.post(`${API}/auth/logout`).catch(() => {});
        localStorage.removeItem('token');
        delete axios.defaults.headers.common.Authorization;
        setToken(null);
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, token, loading, login, logout, handleCallback }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
}
